import { useQueryClient } from "@tanstack/react-query";
import type { ReturnRequestDto } from "../generated/schema";

type UseInvalidateReturnRequestParams = {
  shopId: string;
  returnRequestId: string;
};
type UseUpdateReturnRequestParams = {
  returnRequest: ReturnRequestDto;
};

export function useInvalidateReturnRequest() {
  const queryClient = useQueryClient();

  return (params: UseInvalidateReturnRequestParams) => {
    queryClient.invalidateQueries({
      queryKey: [
        "get",
        "/shops/{shopId}/return-requests/{returnRequestId}",
        {
          params: {
            path: {
              shopId: params.shopId,
              returnRequestId: params.returnRequestId,
            },
          },
        },
      ],
    });
  };
}

export function useUpdateReturnRequestInCache() {
  const queryClient = useQueryClient();

  return (params: UseUpdateReturnRequestParams) => {
    queryClient.setQueryData(
      [
        "get",
        "/shops/{shopId}/return-requests/{returnRequestId}",
        {
          params: {
            path: {
              shopId: params.returnRequest.shopId,
              returnRequestId: params.returnRequest.id,
            },
          },
        },
      ],
      params.returnRequest,
    );
  };
}
